import { render, staticRenderFns } from "./AppBarI18n.vue?vue&type=template&id=19e51f02"
import script from "./AppBarI18n.vue?vue&type=script&lang=js"
export * from "./AppBarI18n.vue?vue&type=script&lang=js"
import style0 from "./AppBarI18n.vue?vue&type=style&index=0&id=19e51f02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports